import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, FlaskConicalIcon, LockIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { TestimonialCard } from '../TestimonialCard';
import { testimonials } from '../../data/programa';
const reassurances = [{
  label: 'Garantía 7 días',
  icon: ShieldCheckIcon
}, {
  label: 'Pago seguro',
  icon: LockIcon
}, {
  label: 'Mercado Pago',
  icon: CreditCardIcon
}];
const stats = [{
  value: '+1.200',
  label: 'Profesionales aplicándolo'
}, {
  value: '6 Tomos',
  label: 'Listos para aplicar'
}, {
  value: '6 Bonos',
  label: 'Incluidos siempre'
}, {
  value: '4.75/5',
  label: 'Calificación'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="relative overflow-hidden border-b border-line bg-ink" data-id="element-136" data-mp="15ki9y7rm3h4w">
      <div className="radial-gold absolute inset-0" aria-hidden="true" data-id="element-137" data-mp="15ifg1cnc93uw" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" aria-hidden="true" data-id="element-138" data-mp="1ak4pinuwx9gv" />

      <div className="relative mx-auto max-w-content px-6 py-16 lg:px-10 lg:py-20" data-id="element-139" data-mp="9lgbr33fjcvv">
        <nav className="mb-14 flex justify-center" aria-label="Principal" data-id="element-140" data-mp="4qsvfrikxosd">
          <span className="inline-flex items-center gap-2.5 text-[14px] font-bold uppercase leading-none tracking-[0.22em] text-ice" data-id="element-141" data-mp="3vvj4o5sntkpj">
            <FlaskConicalIcon className="h-5 w-5 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-142" data-mp="3rvs45adbzq7t" />
            DigiLab<span className="text-gold" data-id="element-143" data-mp="nfhc21a157yc">&nbsp;Academy</span>
          </span>
        </nav>

        <div className="mx-auto max-w-4xl text-center" data-id="element-144" data-mp="iohdysp6cju9">
          <motion.h1 className="text-[36px] font-bold leading-[1.05] tracking-[-0.02em] text-ice sm:text-[52px] lg:text-[60px]" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease
        }} style={{
          fontSize: "32px"
        }} data-id="element-145" data-mp="imxz96j62gul">
            Llegá a las 17:00 con la misma energía{' '}
            <span className="text-gold-sheen" data-id="element-146" data-mp="30o0e5nxvxmfo">que llegaste a las 9:00</span>
          </motion.h1>

          <motion.div className="relative mt-10" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease
        }} data-id="element-147" data-mp="35n38oeg8oa9e">
            <div className="absolute inset-x-6 top-[12%] h-[76%] rounded-[40px] bg-gold/20 blur-[70px] sm:inset-x-16" aria-hidden="true" data-id="element-148" data-mp="2huecy9sk18xu" />
            <img src="https://cdn.magicpatterns.com/uploads/hrdD8f6m4khXKxXUMmAVUL/Megapack_3.png" alt="Mega Pack Atleta Corporativo: 6 tomos y 6 bonos" className="relative mx-auto w-full max-w-3xl rounded-2xl shadow-[0_0_60px_rgba(255,159,28,0.22)]" width={1536} height={1024} data-id="element-149" data-mp="2msfv8si5p489" />
          </motion.div>

          <motion.p className="mx-auto mt-8 max-w-2xl text-[17px] leading-[1.7] text-ice [text-shadow:0_0_18px_rgba(203,213,225,0.35),0_0_40px_rgba(148,163,184,0.22)] sm:text-[18px]" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.12,
          ease
        }} data-id="element-150" data-mp="63shl1uxk4k6">
            El programa que optimiza tu energía, foco y rendimiento durante toda tu jornada laboral. Sin gimnasio. Sin dietas. Sin sacrificar tu carrera
          </motion.p>

          <motion.div className="mt-7" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.16,
          ease
        }} data-id="element-151" data-mp="2ec75541ftydx">
            <span className="inline-flex items-center gap-2.5 whitespace-nowrap rounded-full border border-gold/40 bg-line px-4 py-2 text-[12px] font-medium text-ice shadow-[0_0_16px_rgba(255,159,28,0.2)] sm:text-[13px]" data-id="element-152" data-mp="2jcleqqiotge2">
              <UsersIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-153" data-mp="oz3m4p3fdtc6" />
              +1.200 profesionales ya lo aplican
            </span>
          </motion.div>

          <motion.div className="mx-auto mt-10 max-w-md" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.2,
          ease
        }} data-id="element-154" data-mp="veu2k6u64fkv">
            <CTAButton pulse contentName="Programa Atleta Corporativo" value={24990} data-id="element-155" data-mp="15ci0f5n2m379">
              Accede desde $24.990
            </CTAButton>
            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[13px] text-cool" data-id="element-156" data-mp="co2wpf9e37b8">
              {reassurances.map(item => <li key={item.label} className="inline-flex items-center gap-2" data-id="element-157" data-mp="hmnnko2r4en0">
                  <item.icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-158" data-mp="mee4jcw720ne" />
                  {item.label}
                </li>)}
            </ul>
          </motion.div>

          <motion.dl className="mx-auto mt-14 grid max-w-2xl grid-cols-2 gap-x-6 gap-y-8 border-t border-line pt-10 text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.26,
          ease
        }} data-id="element-159" data-mp="3q38wk4vdv7q4">
            {stats.map(stat => <div key={stat.label} data-id="element-160" data-mp="1y5v87w8h60q4">
                <dt className="sr-only" data-id="element-161" data-mp="1t8btywbs1ny6">{stat.label}</dt>
                <dd data-id="element-162" data-mp="1t7tnz7zbbvd2">
                  <span className="block text-3xl font-bold tracking-tight text-gold" data-id="element-163" data-mp="1tafvx8q48cvt">
                    {stat.value}
                  </span>
                  <span className="mt-1.5 block text-[12px] uppercase tracking-[0.1em] text-cool" data-id="element-164" data-mp="1jia4q17otzho">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </motion.dl>
        </div>

        <motion.div className="mt-16 grid gap-6 lg:grid-cols-3" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.32,
        ease
      }} data-id="element-165" data-mp="1ajf1mxzxx5il">
          {testimonials.map(testimonial => <TestimonialCard key={testimonial.name} testimonial={testimonial} data-id="element-166" data-mp="qvah343igltt" />)}
        </motion.div>
      </div>
    </header>;
}